module.exports = __webpack_public_path__ + "img/offer-icon.278f64f1.png";